import { createElement } from "react";
import type { ComponentType } from "react";

import { adaptersFeature } from "./adapters";
import { campaignsFeature } from "./campaigns";
import { ivrFeature } from "./ivr";
import { orchestratorFeature } from "./orchestrator";
import { qcFeature } from "./qc";
import type { FeatureModule, FeatureNavItem, FeatureNavSlot, FeatureRoute } from "./types";

export const FEATURES: FeatureModule[] = [
  ivrFeature,
  campaignsFeature,
  qcFeature,
  adaptersFeature,
  orchestratorFeature,
];

function hasRoute(feature: FeatureModule): feature is FeatureModule & { element: NonNullable<FeatureModule["element"]> } {
  return Boolean(feature.path) && Boolean(feature.element);
}

export function featureRoutes(): FeatureRoute[] {
  return FEATURES.filter(hasRoute).map((feature) => ({
    path: feature.path,
    element: createElement(feature.element as ComponentType),
  }));
}

export function featureNav(slot: Exclude<FeatureNavSlot, false>): FeatureNavItem[] {
  return FEATURES.filter((feature) => (feature.nav ?? false) === slot && feature.path).map((feature) => ({
    id: feature.id,
    to: feature.path,
    label: feature.label,
  }));
}
